import axios from '../../axios'

/**
 * 批量生成电子教学日志
 * @param {*} data 
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=38306530  20240627 
 */
export const batchCreateTeachingLog = data => {
  return axios({
    url: '/stage/createClassPdfBatch',
    method: 'post', data
  })
}
/**
 * 导出Excel
 * @param schoolId 驾校ID
 * @param inscode 驾校统一编号
 * @param idcard
 * @param name
 * @param subject 1:第一部分；2:第二部分；3:第三部分；4:第四部分
 * @param stunum 学员统一编号
 * @param state 审核状态：0：待审核 1：待送审 2：待复审3：待终审 4：审核失败 5：终审成功
 * @param sendTime 阶段上报时间
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=703072
 */
export const exportExcel = data => {
  return axios({
    url: '/stage/exportExcel',
    method: 'post',
    responseType: 'blob',
    data,
  })
}
// 保存
export const save = (data) => {
    return axios({
        url: '/stage/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/stage/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/stage/list',
        method: 'post',
        data
    })
}
// 明细查询
export const detailView = (data) => {
    return axios({
        url: '/stage/detail',
        method: 'post',
        data
    })
}
// 上报阶段
export const report = (data) => {
  return axios({
    url: '/stage/reportBatch',
    method: 'post',
    data
  })
}
export const getSignStr = (data) => {
  return axios({
    url: '/stage/getSignStr',
    method: 'post',
    data
  })
}
// 上报阶段-签章
export const reportSign = (data) => {
  return axios({
    url: '/stage/reportSignBatch',
    method: 'post',
    data
  })
}
// 查看PDF
export const viewPdfBase64 = (data) => {
  return axios({
    url: '/stage/viewPdf',
    method: 'post',
    data
  })
}
// 同步上报学时
export const syncStageBatch = (data) => {
  return axios({
    url: '/stage/syncStageBatch',
    method: 'post',
    data
  })
}
// 同步阶段上报状态
export const syncStageViewBatch = (data) => {
  return axios({
    url: '/stage/syncStageViewBatch',
    method: 'post',
    data
  })
}

export const stuHourList = (data) => {
  return axios({
    url: '/stage/stuHourList',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/stage/stage.js